/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLibraryAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 22v-4h4V2H6v4H2v16zm2-6h-2V6H8V4h12zm-4 4H4V8h12zm-5-2v-3h3v-2h-3v-3H9v3H6v2h3v3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLibraryAdd as LibraryAdd };
